import { Capacitor } from '@capacitor/core';

export function isNative() {
  return Capacitor.isNativePlatform();
}

export function isIOS() {
  return isNative() && Capacitor.getPlatform() === 'ios';
}

export function isAndroid() {
  return isNative() && Capacitor.getPlatform() === 'android';
}

export function isWeb() {
  return Capacitor.getPlatform() === 'web';
}
